module.exports = __webpack_public_path__ + "static/media/looqu3.1912d897.png";